export default __webpack_public_path__ + "static/media/screen1.d9332558.png";